import { CurrentUser } from "../../types/authTypes"
import { ContextStatus, initialContextStatus } from "../../types/statusTypes"

export interface State {
  authUser: firebase.default.User | null
  currentUser: CurrentUser | null
  isUserLoggedIn: boolean
  status: ContextStatus
}

export enum Actions {
  setUser = "SET_USER",
  setStatus = "SET_STATUS"
}

interface Action {
  type: Actions
  payload: Partial<State>
}


export const initialState: State = {
  authUser: null,
  currentUser: null,
  isUserLoggedIn: false,
  status: initialContextStatus,
}

const authReducer = (state: State, action: Action): State => {
  const { type, payload } = action

  switch (type) {
    case Actions.setUser:
      // console.log("SET_USER", payload)

      return {
        ...state,
        authUser: payload.authUser,
        currentUser: payload.currentUser,
        isUserLoggedIn: payload.isUserLoggedIn,
      }

    case Actions.setStatus:
      // console.log("SET_STATUS", payload)
      return {
        ...state,
        status: payload.status!,
      }

    default:
      throw new Error(`No case for type ${type} found in authReducer.`)

  }
}

export default authReducer
